import { supabaseClient } from 'supabase'
import { ImportBeatRow } from './listImportBeats'

/**
 * The keys an admin may set on a new beat. `active` is left to its column
 * default (true); `created_at` / `updated_at` belong to the database.
 */
export type CreateImportBeatParams = {
  handle: string
  page_url: string
  notes: string | null
  area_city_id: number | null
  area_municipality: string | null
}

/**
 * Add one beat. Gated by the RLS policy "Admins add import beats" (0028) and
 * the column-level INSERT grant on import_beats (0028).
 *
 * The row sent is a NEW object holding only the five keys above — caller
 * input is never spread, so a stray key can never reach the server. Always a
 * plain `.insert`, never an insert-or-update: that needs UPDATE on handle and
 * page_url, which 0028 does not grant, and would silently re-point an
 * existing beat if it did (D-16). A duplicate handle is a 23505 for the form.
 *
 * The raw PostgREST error is thrown unchanged (never swallowed, never
 * rewrapped) so `mapBeatError` can read its code and message.
 */
export const createImportBeat = async (
  params: CreateImportBeatParams
): Promise<ImportBeatRow> => {
  const row = {
    handle: params.handle,
    page_url: params.page_url,
    notes: params.notes,
    area_city_id: params.area_city_id,
    area_municipality: params.area_municipality
  }

  const { data, error } = await supabaseClient
    .from('import_beats')
    .insert(row)
    .select()
    .single()

  if (error) {
    throw error
  }
  return data as ImportBeatRow
}
